import { BsChevronRight } from "react-icons/bs";
import { Button } from "antd";

//TODO: Once the modules is ready, remove the d-none class and add the handlers
const ViewAllButtonWidget = ({
    style = {}
}) => (
    // <div className="d-flex justify-content-end">
    <div className="d-none justify-content-end">
        <Button
            type="link"
            className="text-decoration-none my-3 px-0"
            style={{
                color: "#0078AA",
                fontSize: 14,
                fontWeight: 700,
                lineHeight: 16,
                ...style,
            }}
        >
            VIEW ALL&nbsp;<BsChevronRight size={16} color="#0078AA" />
        </Button>
    </div>
);

export default ViewAllButtonWidget;